import {
  AbstractType,
  Injectable,
  InjectionToken,
  Injector,
  Type,
} from '@angular/core';
import { DashboardModuleKey } from '@app/components/xux-dnd/types';
import { XuxDndCacheActions } from '@app/store/actions/xux-dnd-cache/xux-dnd-cache.actions';
import { isFunction } from 'lodash';
import { lazyInject } from '@app/containers/base/decorators';
import { IXuxDndCacheModuleData } from '@app/store/reducers/dashboard-cache/xux-dnd-cache.type';

@Injectable()
export class XuxDndCacheService {
  @lazyInject(XuxDndCacheActions)
  private XuxDndCacheActions: XuxDndCacheActions;

  public constructor(public injector: Injector) {}

  public inject<T>(
    token: Type<T> | InjectionToken<T> | AbstractType<T>,
    notFoundValue?: T,
  ): T {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }

  public createFormValueChangeHandler(moduleKey: DashboardModuleKey) {
    return (data: IXuxDndCacheModuleData) => {
      if (!data) return;

      this.XuxDndCacheActions.dispatchSetCacheItemAction(moduleKey, data);
    };
  }

  public getCacheValueByModuleKey(moduleKey: DashboardModuleKey): any {
    return this.XuxDndCacheActions.getCachedValueByKey(moduleKey);
  }
}
